import { Link, CopyButton, Text, SimpleCallback } from 'platform-components/common';
import React from 'react';

import { useRegistrationLinkMetrika } from 'common.components/user/hooks';

import './lesson-view__registration-link-controls.scss';

interface Props {
    link: string | null;
    onFallbackClick: SimpleCallback;
}

export const SpecCourseLessonViewRegistrationLinkControls = ({ link, onFallbackClick }: Props) => {
    const { ymTeacherLinkCopy } = useRegistrationLinkMetrika();

    if (!link) {
        return null;
    }

    return (
        <>
            <CopyButton
                className="teacher-spec-course-lesson-view__registration-copy-link-button"
                onButtonClick={() => ymTeacherLinkCopy('olympiad', 'list_copy')}
                text={link}
            />
            <Link mix="teacher-spec-course-lesson-view__registration-fallback-link" onClick={onFallbackClick} pseudo>
                <Text id="specCourse.lessonView.registrationLink" />
            </Link>
        </>
    );
};
